import React, { useState, useEffect } from 'react';
import { Box, Typography, Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import axios from 'axios';

const CarouselContainer = styled(Box)(({ theme }) => ({
  width: '95%',
  margin: '0 auto',
  overflow: 'hidden',
  position: 'relative',
}));

const LogoTrack = styled(Box)(({ theme }) => ({
  display: 'flex',
  willChange: 'transform',
}));

const LogoItem = styled(Box)(({ theme }) => ({
  flex: '0 0 20%',
  padding: theme.spacing(2),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const ClientLogo = styled('img')(({ theme }) => ({
  maxWidth: '100%',
  height: 'auto',
  maxHeight: '80px',
  filter: 'grayscale(100%)',
  opacity: 0.7,
  transition: 'all 0.3s ease',
  '&:hover': {
    filter: 'grayscale(0%)',
    opacity: 1,
  },
}));

const Section4 = () => {
  const [users, setUsers] = useState([]);
  const [position, setPosition] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get('https://admin.bizstor.lk/public/api/users');
        setUsers(response.data);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    fetchUsers();
  }, []);

  const clientLogos = users
    .map((user, index) => ({
      id: user.id || index,
      name: user.name || `User ${index + 1}`,
      logo: (user.email === "bizstoradmin@gmail.com" || user.email === "user@gmail.com" || user.email === "prasadsandaruwa715@gmail.com" )
        ? null
        : user.image
          ? `https://admin.bizstor.lk/storage/app/public/images/${user.image}`
          : null,
    }))
    .filter(client => client.logo); 

  const extendedLogos = [...clientLogos, ...clientLogos]; 

  useEffect(() => {
    const interval = setInterval(() => {
      setPosition((prev) => prev + 1);
      setIsTransitioning(true);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  // Reset without animation for seamless loop
  useEffect(() => {
    if (position === clientLogos.length) {
      const timeout = setTimeout(() => {
        setIsTransitioning(false);
        setPosition(0);
      }, 500); // Match with transition duration

      return () => clearTimeout(timeout);
    }
  }, [position, clientLogos.length]);

  const trackStyle = {
    transform: `translateX(-${position * (100 / 5)}%)`,
    transition: isTransitioning ? 'transform 0.5s ease' : 'none',
  };

  return (
    <Container maxWidth={false} sx={{ py: 8 }}>
      <Typography
        variant="h6"
        component="h6"
        align="center"
        gutterBottom
        sx={{
          fontWeight: 'bold',
          mb: 6,
          color: 'text.secondary',
        }}
      >
        Partners Who Trust Us
      </Typography>

      <CarouselContainer sx={{ width: '90%' }}>
      <LogoTrack sx={trackStyle}>
      {extendedLogos.map((client, index) => (
      <LogoItem key={`${client.id}-${index}`} title={client.name}>
        <ClientLogo src={client.logo} />
      </LogoItem>
    ))}
    </LogoTrack>
    </CarouselContainer>
    </Container>
  );
};

export default Section4;
